import {Box, Typography} from "@mui/material";
import type {ContentPage} from "../../../../../sdo/ContentPage.ts";

interface ContentPageCardProps {
    page: ContentPage;
    selected: boolean;
    onClick: (page: ContentPage) => void;
}

function ContentPageCard({page, selected, onClick}: ContentPageCardProps) {
    return (
        <Box
            onClick={() => onClick(page)}
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                padding: "8px",
                borderRadius: "10px",
                border: selected ? "1px solid #38ff82" : "0.5px solid #3F464F",
                background: selected
                    ? "linear-gradient(155deg, rgba(0, 143, 130, 0.25) 0%, rgba(0, 38, 53, 0.30) 50%, rgba(0, 0, 0, 0.30) 100%)"
                    : "linear-gradient(155deg, rgba(0, 71, 106, 0.30) 0%, rgba(0, 38, 53, 0.30) 25%, rgba(0, 0, 0, 0.30) 90%, rgba(0, 0, 0, 0.40) 100%)",
                cursor: "pointer",
                transition: "border-color 0.15s, background 0.15s",
                "&:hover": {
                    borderColor: selected ? "#38ff82" : "#7093a0",
                },
            }}
        >
            <Box
                component="img"
                src={page.thumbnailUrl || "/images/content_pages.svg"}
                alt={`Page ${page.pageNumber}`}
                onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
                    (e.target as HTMLImageElement).src = "/images/content_pages.svg";
                }}
                sx={{
                    width: "100%",
                    maxHeight: 100,
                    objectFit: "contain",
                    borderRadius: "6px",
                }}
            />
            <Typography sx={{
                color: selected ? "#38ff82" : "#008F82",
                fontSize: "0.80rem",
                fontWeight: 600,
                marginTop: "6px",
                textAlign: "center",
                transition: "color 0.15s",
            }}>
                Page {page.pageNumber}
            </Typography>
        </Box>
    );
}

export default ContentPageCard;